export const cheatValues = {
  pioneer: {
    'X2': '',
    'Free Spins': '111',
    'Big': 'GHGHG,CCCCA,EFEFE',
    'Mega': '22222,JI1IE,HGFFD',
    'Ultra': 'GHGHG,BBBBA,EFEFE',
  },
  evo10: {
    'X2': 'GGG,GGG,GGG',
    'Free Spins': '',
    'Big': 'DDD,AAA,AHA',
    'Mega': 'HHH,HHH,HAH',
    'Ultra': 'DDD,AAA,AAA',
  },
  ultraHot: {
    'X2': 'BBB,BBB,BBB',
    'Free Spins': '',
    'Big': 'DDD,AAA,AHA',
    'Mega': 'HHH,HHH,HAH',
    'Ultra': 'DDD,AAA,AAA',
  },
  ultrahot: {
    'X2': 'BBB,BBB,BBB',
    'Free Spins': '',
    'Big': 'DDD,AAA,AHA',
    'Mega': 'HHH,HHH,HAH',
    'Ultra': 'DDD,AAA,AAA',
  },

  expandingWild: {
    'X2': '',
    'Free Spins': '111',
    'Big': 'ADADA,G2HGG,ACBCB',
    'Mega': 'AD1EE,A222A,CHGFFD',
    'Ultra': 'ADADA,G22GG,ACBCB',
  },

  pioneer20: {
    'X2': '',
    'Free Spins': '111',
    'Big': 'ADADA,G2HGG,ACBCB',
    'Mega': 'AD1EE,A222A,CHGFFD',
    'Ultra': 'ADADA,G22GG,ACBCB',
  },
  circus: {
    'X2': '',
    'Free Spins': '111',
    'Big': 'GHHBC,DDDDD,HHHHH,FFFFF,ADCHBD',
    'Mega': 'AAAAA,22DDD,HHHHH,FFFFF,AAAAA',
    'Ultra': 'GGGGG,DDDDD,HHHHH,FFFFF,AAAAA',
  },
  crazyHot30: {
    'X2': '',
    'Free Spins': '',
    'Big': 'A11CA,2AAA2,ABCDH',
    'Mega': 'A11CA,2AAA2,22222',
    'Ultra': 'A11CA,2AAA2,AAAAA',
  },
  pioneer30: {
    'X2': '',
    'Free Spins': '111',
    'Big': 'EEEEE',
    'Mega': 'A11CA,2AAA2,22222',
    'Ultra': 'D11CA,AAAAH,ADBGH',
  },
  book: {
    'X2': '',
    'Free Spins': '111',
    'Big': 'GHGHG,HHHHA,EFEFE',
    'Mega': 'AAAEE,AAAAA,CHGFFD',
    'Ultra': 'GHGHG,CCCCA,EFEFE',
  },
  pioneerRespin: {
    'X2': '',
    'Free Spins': '1jjj1',
    'Big': 'AAAAB,GHHGG,ACBCB',
    'Mega': 'AAAEE,A222A,CHGFFD',
    'Ultra': 'ADADA,G2HGG,ACBCB',
  },
  evo20: {
    'X2': '',
    'Free Spins': '111',
    'Big': 'ADADA,G2HGG,ACBCB',
    'Mega': 'AD1EE,A222A,CHGFFD',
    'Ultra': 'ADADA,G22GG,ACBCB',
  },
  evo30: {
    'X2': '',
    'Free Spins': '111',
    'Big': 'EEEEE',
    'Mega': 'A11CA,2AAA2,22222',
    'Ultra': 'D11CA,AAAAH,ADBGH',
  },
  racer: {
    'X2': '',
    'Free Spins': '111',
    'Big': 'ADADA,G2HGG,ACBCB',
    'Mega': 'AD1EE,A222A,CHGFFD',
    'Ultra': 'ADADA,G22GG,ACBCB',
  },
  rabbitrun: {
    'X2': '',
    'Free Spins': '111',
    'Big': 'ADADA,G2HGG,ACBCB',
    'Mega': 'AAAAA,AAAAA,AAAAA',
    'Ultra': 'F2FFH,F2FFH,F2FFH',
  },
  cronus: {
    'X2': '',
    'Free Spins': '111',
    'Big': 'ADADA,G2HGG,ACBCB',
    'Mega': 'AAAAA,AAAAA,AAAAA',
    'Ultra': 'F2FFH,F2FFH,F2FFH',
    'freespin2x': 'freespin2x;',
    'freespin3x': 'freespin3x;',
    'fsNoLow': 'fsNoLow;',
    'fsProgressiveMultiplier': 'fsProgressiveMultiplier;',
    'fsRespin': 'fsWithRespins;',
  },

  cronusBuy: {
    'X2': '',
    'Free Spins': '111',
    'Big': 'ADADA,G2HGG,ACBCB',
    'Mega': 'AAAAA,AAAAA,AAAAA',
    'Ultra': 'F2FFH,F2FFH,F2FFH',
    'freespin2x': 'freespin2x;',
    'freespin3x': 'freespin3x;',
    'fsNoLow': 'fsNoLow;',
    'fsProgressiveMultiplier': 'fsProgressiveMultiplier;',
    'fsRespin': 'fsWithRespins;',
  },

  delorian: {
    'X2': '',
    'Free Spins': '111',
    'Big': 'ADADA,G2HGG,ACBCB',
    'Mega': 'AAAAA,AAAAA,AAAAA',
    'Ultra': 'F2FFH,F2FFH,F2FFH',
    'infinityRespin': 'randomFeature;',
  },

  volatilehot: {
    'X2': '',
    'Free Spins': '111',
    'Big': 'EEEEE',
    'Mega': 'A11CA,2AAA2,22222',
    'Ultra': 'D11CA,AAAAH,ADBGH',
  },
  stickywild: {
    'X2': '',
    'Free Spins': '111',
    'Big': 'ADADA,G2HGG,ACBCB',
    'Mega': 'AAAAA,AAAAA,AAAAA',
    'Ultra': 'F2FFH,F2FFH,F2FFH',
    'infinityRespin': 'randomFeature;',
  },
  zombie: {
    'X2': '',
    'Free Spins': '111',
    'Big': 'ADADA,G2HGG,ACBCB',
    'Mega': 'AAAAA,AAAAA,AAAAA',
    'Ultra': 'F2FFH,F2FFH,F2FFH',
  },
  pioneergamble: {
    'X2': '',
    'Free Spins': '111',
    'Big': 'ADADA,G2HGG,ACBCB',
    'Mega': 'AAAAA,AAAAA,AAAAA',
    'Ultra': 'F2FFH,F2FFH,F2FFH',
  },
  cascadelines: {
    'X2': '',
    'Free Spins': '111',
    'Big': 'GHHBC,DDDDD,HHHHH,FFFFF,ADCHBD',
    'Mega': 'AAAAA,22DDD,HHHHH,FFFFF,AAAAA',
    'Ultra': 'GGGGG,DDDDD,HHHHH,FFFFF,AAAAA',
  },
}
